export default __webpack_public_path__ + "static/media/Sewio.e4488c78.png";